import { get, del, post, put, download } from "@utils/axios";

const api = "salarySheets";
export const getAllDataReq = (payload) => {
  return get(`${api}?page=${payload.page}&filters=${payload.filters}`)
};

// Disbursement Register (audit-ready list of actual salary payments for the month)
export const downloadDisbursementRegisterReq = (payload) => {
  return download(`disbursements/register/download?month=${payload.month || ''}`)
};

export const createDataReq = (payload) => {
  return post(`${api}`, payload);
};

export const updateDataReq = (payload) => {
  return put(`${api}/${payload.id}`, payload);
};
export const cancelRequestReq = (payload) => {
  return post('cancelRequest', payload);
};

export const deleteDataReq = (payload) => {
  return del(`${api}/${payload.id}?page=1&filters=${payload.filters}`);
};

export const getRosterReq = (payload) => {
  return post(`${api}/getRoster`, payload);
};
export const getExpectedTimeReq = (payload) => {
  return get(`${api}/getExpectedTime?&attendance_date=${payload.date}&employment_id=${payload.employment_id}`);
};

export const getFilterReq = (payload) => {
  return get(`filters?${localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1}&fields=page=1&filters=supporting_fields_|employees,payroll,trashed_type;organization_structure_fields_|location,branch,department;preset_|salary_sheet;`)
}
export const onDateChange = (payload) => {
  return post(`${api}/dateChange?&`, payload)
}
export const onShiftSelectionChangeReq = (payload) => {
  return post(`${api}/shiftSelectionChange?&`, payload)
}

export const getRelatedDataByReqIdReq = (payload) => {
  return get(`${api}/${payload}`)
};

//download 
export const downloadSalarySheetReq = (payload) => {
  return download(`${api}/download?filters=${payload.filters}`)
};
export const downloadSalarySheetPdfReq = (payload) => {
  return download(`${api}/downloadPdf?filters=${payload.filters}`)
};
export const downloadDepartmentSalarySheetReq = (payload) => {
  return download(`${api}/downloadDepartmentWise?filters=${payload.filters}`)
};

//recalculate payslip 
export const regeneratePayslipReq = (id) => {
  return post(`${api}/regenerate/${id}`)
};

